import { object, number, array } from '@gogame/schemas';

import {
  FILTER_AFFILIATES,
  FILTER_EVENTS,
  FILTER_PARTNERS,
  FILTER_APPLICATIONS,
} from 'scenes/Integrations/constants';

export const EMPTY_FILTERS = {};

export const filtersSchema = object({
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_EVENTS]: array(number()),
  [FILTER_PARTNERS]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
});
